import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import commonReducers from "../reducers"

// The home page's ONLINE counter: non-bot accounts the server has seen in the last hour.
export const thunk = createAsyncThunk("common/population", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("/online/")
    return { population: response.data.population }
  } catch (error) {
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = commonReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
